import React from 'react';

import {labels} from '../../../../util/utils';
import Utility from '../../../../util/utilityfunctions';

import OutputText from '@ey/canvascoreservices/OutputText';

import ProgressLoader from '../../../CoreWrappers/ProgressLoader';
import Modal from '../../../CoreWrappers/Modal';
import ErrorSummary from '../../ErrorSummary/ErrorSummary';
import StyledProjectConfirmationModal from './StyledProjectConfirmationModal';

const ProjectConfirmationModal = ({
	show,
	onHide,
	onConfirm,
	isLoading,
	title,
	confirmLabel,
	projectName = '',
	instructional = null,
	instructionalSecondary = null
}) => {
	const renderInstructional = (text) => <OutputText light>{Utility.createRichTextElement(text)}</OutputText>;

	const props = {
		show,
		modalsize: 'small',
		title,
		labels: {
			modalConfirmBtnLabel: labels.confirm,
			modalCancelBtnLabel: labels.cancelLabel,
			modalCloseBtnTitletip: labels.closeLabel
		},
		onClose: onHide,
		onOkClick: onConfirm,
		isOkDisabled: isLoading,
		isCancelDisabled: isLoading,
		closeButtonProps: {
			disabled: isLoading
		}
	};

	return (
		show && (
			<Modal {...props}>
				{isLoading && <ProgressLoader />}
				<ErrorSummary />
				<StyledProjectConfirmationModal>
					{instructional && renderInstructional(instructional)}
					{instructionalSecondary && renderInstructional(instructionalSecondary)}
					<div>
						<OutputText light className="no-shrink">
							{`${labels.projectName}:`}
						</OutputText>
						<OutputText ellipsis title={projectName}>
							{projectName}
						</OutputText>
					</div>
				</StyledProjectConfirmationModal>
			</Modal>
		)
	);
};

ProjectConfirmationModal.propTypes = {};

export default ProjectConfirmationModal;
